<template>
  <div class="col-xs-12 attributesBlock productColorsBlock">
    <span class="title"><small>{{attributeGroup.attributeGroupName}}</small> <span v-show="getSelectedText.length > 0">{{ getSelectedText }}</span></span>
    <button
      v-for="attribute in attributeGroup.attributes"
      :key="attribute.attributeId"
      v-on:click="setSelected(attribute.attributeId)"
      :style="'background:'+ attribute.attributeDisplayValue">
      <span><i :class="selected === attribute.attributeId ? 'fa fa-check' : 'fa'"></i></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AttributeHexSelector',
  props: ['attributeGroup'],
  data () {
    return {
      version: '0.0.2',
      selected: null
    }
  },
  computed: {
    getSelectedText () {
      if (!this.selected) {
        return ''
      }
      let selected = this.attributeGroup.attributes.find(item => item.attributeId === this.selected)
      if (!selected) {
        return ''
      }
      return selected.attributeName
    }
  },
  methods: {
    setSelected (attributeId) {
      this.selected = attributeId
      this.$emit('attribute-clicked', attributeId)
    }
  }
}
</script>
